export const OPTIMIZELY_UUID_AGE = 365 * 5 * 60 * 60 * 24;
export const OPTIMIZELY_UUID_COOKIE_NAME = "ANALYTICS_UUID";
export const BASE_USER_ATTRIBUTES = {
  platform: "public-site"
};

export enum OPTIMIZELY_FEATURE_FLAGS {
  BACKEND_COMMISSION_REFERRALS = "backend_commission_referrals",
  HIDDEN_TRADING_PAIRS = "hidden_trading_pairs",
  COINGECKO_FOR_MISSING_CHART_DATA = "mobile_coingecko_for_missing_chart_data",
  WEB_COINGECKO_ALL_TIME_DATA = "exchange_coingecko_all_time_data",
  COINGECKO_TOKEN_MAP = "coingecko_token_map",
  EXLCUDED_CURRENCIES_LIST = "web_pubsite_excluded_currencies",
  SERVICE_OUTAGE_BANNER = "service_outage_banner"
}

export enum OPTIMIZELY_FEATURE_VARIABLES {
  COMMISSION_TIERS = "commission_tiers",
  ADDITIONAL_TOKEN_MAP = "additionalTokenMap",
  FIAT_PAIRS = "fiat_pairs",
  INCLUDE_ALL_COINS = "includeAllCoins",
  INCLUDED_COINS = "includedCoins",
  INCLUDED_TIME_FRAMES = "includedTimeFrames",
  EXLCUDED_CURRENCIES_LIST = "exclusions",
  SERVICE_OUTAGE_MESSAGE = "serviceOutageMessage"
}

export const OPTIMIZELY_FEATURE_VARIABLES_MAP = {
  [OPTIMIZELY_FEATURE_FLAGS.BACKEND_COMMISSION_REFERRALS]: {
    [OPTIMIZELY_FEATURE_VARIABLES.COMMISSION_TIERS]:
      OPTIMIZELY_FEATURE_VARIABLES.COMMISSION_TIERS
  },
  [OPTIMIZELY_FEATURE_FLAGS.COINGECKO_TOKEN_MAP]: {
    [OPTIMIZELY_FEATURE_VARIABLES.ADDITIONAL_TOKEN_MAP]:
      OPTIMIZELY_FEATURE_VARIABLES.ADDITIONAL_TOKEN_MAP
  },
  [OPTIMIZELY_FEATURE_FLAGS.COINGECKO_FOR_MISSING_CHART_DATA]: {
    [OPTIMIZELY_FEATURE_VARIABLES.INCLUDE_ALL_COINS]:
      OPTIMIZELY_FEATURE_VARIABLES.INCLUDE_ALL_COINS,
    [OPTIMIZELY_FEATURE_VARIABLES.INCLUDED_COINS]:
      OPTIMIZELY_FEATURE_VARIABLES.INCLUDED_COINS,
    [OPTIMIZELY_FEATURE_VARIABLES.INCLUDED_TIME_FRAMES]:
      OPTIMIZELY_FEATURE_VARIABLES.INCLUDED_TIME_FRAMES
  },
  [OPTIMIZELY_FEATURE_FLAGS.SERVICE_OUTAGE_BANNER]: {
    [OPTIMIZELY_FEATURE_VARIABLES.SERVICE_OUTAGE_MESSAGE]:
      OPTIMIZELY_FEATURE_VARIABLES.SERVICE_OUTAGE_MESSAGE
  }
};
